import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextContentFr = () => {
    return (
        <HighlightedText
            text="Bonus de 325% + 400 TOURS GRATUITS"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['325%', 'TOURS']}
            className={cls.text}
        />
    )
}
